<template>
  <section class="container">
    <ul class="accordion">
      <li v-if="filteredStrap">
        <button
          type="button"
          id="title-strap"
          :aria-expanded="active === 0 ? 'true' : 'false'"
          aria-controls="body-strap"
          @click="switchTab(0)"
        >
          <i class="icon-strap"></i>
          <p class="specification-title font-small-title -upper">
            {{ $t('Strap') }}
          </p>
        </button>
        <transition-expand>
          <div
            v-if="active === 0"
            id="body-strap"
            role="region"
            aria-labelledby="title-strap"
          >
            <table :aria-describedby="$t('Table') + ': ' + $t('Strap')">
              <tr
                v-if="
                  simpleProducts[STRAP_SIZE_KEY] &&
                    simpleProducts[STRAP_SIZE_KEY].length
                "
                :key="'wrist-size'"
              >
                <th scope="row">
                  {{ $t('Wrist size') }}
                </th>
                <td>
                  <ul class="aligned-list">
                    <li
                      v-for="el in simpleProducts[STRAP_SIZE_KEY]"
                      :key="`${el.id}-straps`"
                    >
                      <strong class="h5">{{
                        el.option_value_strap_size
                      }}</strong>
                      <span>{{ el.strap_min_length | convertToCM }} -
                        {{ el.strap_max_length | convertToCM }} cm</span>
                    </li>
                  </ul>
                </td>
              </tr>

              <tr v-for="(strapSpecification, key) in filteredStrap" :key="key">
                <th scope="row">
                  {{ $t(key) }}
                </th>
                <td>{{ strapSpecification }}</td>
              </tr>
              <tr
                v-if="
                  item.compatible_watches_collections &&
                    item.compatible_watches_collections.length
                "
                :key="'compatible-watches'"
              >
                <th scope="row">
                  {{ $t('Compatibility') }}
                </th>
                <td>
                  <ul class="aligned-list">
                    <li
                      v-for="el in item.compatible_watches_collections"
                      :key="`${el.id}-straps`"
                    >
                      {{ el }}
                    </li>
                  </ul>
                </td>
              </tr>
            </table>
          </div>
        </transition-expand>
      </li>
    </ul>
    <div class="btn-sheet font-btn" v-if="item.pdf">
      <button class="btn" @click="onClick($event, item)">
        {{ $t('Download product sheet') }}
      </button>
      <!-- <a v-if="item.pdf" :href="fileUrl + item.pdf" target="_blank" rel="nofollow noreferrer noopener" class="btn" @click="callGTM">{{ $t('Download product sheet') }}</a> -->
    </div>
  </section>
</template>

<script>
import { ReadyHook } from 'vue-asyncready'
import config from 'config'
import { STRAP_SIZE_KEY } from '../utilities'
import { currentStoreView } from '@vue-storefront/core/lib/multistore'
import SearchQuery from '@vue-storefront/core/lib/search/searchQuery'
import { quickSearchByQuery } from '@vue-storefront/core/lib/search'

const storeView = currentStoreView()

export default {
  props: ['item', 'items', 'pagePosition', 'siblingsComponents'],
  name: 'TechnicalSpecificationStraps',
  mixins: [ReadyHook],
  filters: {
    convertToCM: function(value) {
      if (!value) return ''
      return value / 10
    }
  },
  data() {
    return {
      active: -1,
      STRAP_SIZE_KEY,
      simpleProducts: { [STRAP_SIZE_KEY]: [] }
    }
  },
  created() {
    this.queryWristSize()
  },
  computed: {
    fileUrl() {
      return config.magento2.fileUrl
    },
    // filtered functions are used to remove empty values from the specification lists
    filteredStrap() {
      if (!this.item.strap) return null
      const filtered = Object.fromEntries(
        Object.entries(this.item.strap).filter(
          ([, value]) => value !== null && value !== undefined && value !== ''
        )
      )
      return Object.keys(filtered).length ? filtered : null
    }
  },
  methods: {
    queryWristSize() {
      const skus =
        this.item && this.item.bundle_options
          ? this.item.bundle_options
            .map(bundle => bundle.product_links.map(link => link.sku))
            .reduce((acc, curr) => [...acc, ...curr])
          : []
      const productQuery = ({ skus }) => {
        let query = new SearchQuery().applyFilter({
          key: 'sku',
          value: { in: skus }
        })
        return query
      }
      quickSearchByQuery({
        query: productQuery({ skus }),
        entityType: 'product',
        storeCode: storeView.storeCode,
        start: 0,
        size: 100
      })
        .then(({ items }) => items)
        .then(items => {
          return items.reduce((acc, curr) => {
            if (!acc[curr['attribute_set_id']]) {
              acc[curr['attribute_set_id']] = []
            }
            acc[curr['attribute_set_id']].push(curr)
            return acc
          }, {})
        })
        .then(groups => {
          this.simpleProducts =
            groups && groups[STRAP_SIZE_KEY] ? groups : this.simpleProducts
          this.strapSize = groups[STRAP_SIZE_KEY]
            ? groups[STRAP_SIZE_KEY].findIndex(
              strap =>
                strap.option_value_strap_size === 'Standard' &&
                  strap.stock &&
                  strap.stock.is_in_stock
            )
            : null
          this.strapSize = this.strapSize === -1 ? null : this.strapSize
        })

      if (this.strapSize === null) {
        this.strapSize = 0
        this.strapSize = null
      }
    },
    onClick($event, item) {
      $event.preventDefault()
      window.open(item.pdf, '_blank')
      this.callGTM()
    },
    switchTab(v) {
      this.active = this.active === v ? -1 : v
      let interactionType = ['Strap']
      this.$gtm.trackEvent({
        event: 'productFeature',
        interactionType: interactionType[v],
        value: this.active !== -1
      })
    },
    callGTM() {
      this.$gtm.trackEvent({
        event: 'download',
        productName: this.$route.params.uid
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~theme/css/core';

section {
  margin-top: 6rem;
  margin-bottom: 6rem;
  color: var(--zenith-component-text);
}

.accordion {
  margin: 0 auto;
  padding: 0;
  max-width: 110rem;
  list-style: none;
  border-bottom: 1px solid var(--zenith-border);

  .specification-title {
    color: var(--zenith-component-text);
  }
  @include bp(max md) {
    margin: 0 -1.5rem;
  }

  #body-function {
    table {
      tr {
        td {
          white-space: pre-line;
        }
      }
    }
  }

  button {
    position: relative;
    display: flex;
    width: 100%;
    padding: 0;

    height: 7rem;
    align-items: center;
    justify-content: space-between;
    border: none;
    background: none;
    border-top: 1px solid var(--zenith-border);
    color: var(--zenith-component-text);

    @include bp(max md) {
      padding: 0 1.5rem;
    }

    i {
      font-size: em(40, 16);
      margin-right: 3.4rem;

      @include bp(max md) {
        margin-right: 2rem;
      }
    }

    .specification-title {
      margin-bottom: 0;
      margin-right: auto;
    }

    &:after {
      font-family: 'zenith', sans-serif !important;
      speak: none;
      line-height: 1;
      font-size: em(30);
      font-style: normal;
      font-weight: normal;
      font-variant: normal;
      text-transform: none;

      /* Better Font Rendering =========== */
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      content: '\e909';
      transform: rotate(0);
      transition: all 0.2s ease-in-out;
    }

    &[aria-expanded='false']:after {
      transform: rotate(-45deg);
    }
  }

  table {
    width: auto;
    margin: 1rem 2rem 1rem 7rem;

    @include bp(max md) {
      margin: 0 2rem 1rem 7rem;
    }

    td,
    th {
      width: 100%;
      padding-bottom: 2rem;
    }
    th:first-child {
      width: auto;
      white-space: nowrap;
      padding-right: 4rem;
      text-transform: uppercase;
    }
  }

  div[role='region'] {
    div {
      margin: 1rem 2rem 3rem 9.4rem;

      @include bp(max md) {
        margin: 0 2rem 3rem 7.5rem;
      }
    }
  }
}

.btn-sheet {
  width: 100%;
  text-align: center;

  .btn {
    margin: 3rem 0;
  }
}
</style>
